import { useTheme, useMediaQuery } from '@mui/material'

export const useResponsive = () => {
    const theme = useTheme()

    const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // < 600px
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')) // 600-900px
    const isDesktop = useMediaQuery(theme.breakpoints.up('md')) // >= 900px
    const isLargeDesktop = useMediaQuery(theme.breakpoints.up('lg')) // >= 1200px
    // Describes the PRIMARY input mechanism (touch/stylus vs mouse/trackpad),
    // independent of viewport size — a resized desktop window is still
    // `pointer: fine`, and a large landscape tablet is still `pointer: coarse`.
    const isCoarsePointer = useMediaQuery('(pointer: coarse)')

    return { isMobile, isTablet, isDesktop, isLargeDesktop, isCoarsePointer }
}
